import { Elements } from "@stripe/react-stripe-js";
import StripeExpressCheckoutPaymentRequest from "./StripeExpressCheckoutPaymentRequest";

const StripeExpressCheckout = (props) => {
  const { stripePromise, information, summary, shipping, urls, colors } = props;

  const options = {
    mode: "payment",
    amount: summary.total_in_cents,
    currency: information.currency_code,
    paymentMethodTypes: ["card"],
  };

  return (
    <>
      {stripePromise && (
        <Elements stripe={stripePromise} options={options}>
          <StripeExpressCheckoutPaymentRequest
            information={information}
            summary={summary}
            shipping={shipping}
            urls={urls}
            colors={colors}
          />
        </Elements>
      )}
    </>
  );
};

export default StripeExpressCheckout;
